
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonPulldown from '@/components/molecules/ButtonPulldown.vue'
import { SubjectCode } from '@/const/SubjectCode'

/**
 * 教科選択ボタン
 */
@Component({
  components: {
    ButtonPulldown,
  },
})
export default class SubjectSelectButton extends Vue {
  /** 選択中の教科 */
  @Prop()
  private subjectMaster!: SubjectCode.SubjectMaster

  /** ボタンの文字色 */
  private textColor = '--color-subject__text'

  /**
   * ボタンの背景色を設定する
   *
   * @returns css：背景色指定
   */
  private get setStyle(): { [key: string]: string } {
    const style = this.subjectMaster.color
    return {
      '--text-color': `var(${this.textColor})`,
      '--subject-color': `var(${style})`,
    }
  }

  /**
   * ボタンのラベル
   *
   * @returns 教科コードのラベル
   */
  private get label(): string {
    return this.subjectMaster.label
  }

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
